module.exports = {
	"apiKey": "47586461",
	"sessionId": "2_MX40NzU4NjQ2MX5-MTY2NTM3Mjg5MjQ3NX4zck53UUpJM2RiekVqaEFZNlBzYXBDWG1-fg",
	"token": "T1==cGFydG5lcl9pZD00NzU4NjQ2MSZzaWc9NWY3MmYwZDkxNDkxZWU4ZGMyMjdiNTZmYzhmYmQwYmE5YjQ2MTU2MzpzZXNzaW9uX2lkPTJfTVg0ME56VTROalEyTVg1LU1UWTJOVE0zTWpnNU1qUTNOWDR6Y2s1M1VVcEpNMlJpZWtWcWFFRlpObEJ6WVhCRFdHMS1mZyZjcmVhdGVfdGltZT0xNjY1MzcyOTEzJm5vbmNlPTAuMzQ5OTI5NDk5NTM3MzEyMzQmcm9sZT1wdWJsaXNoZXImZXhwaXJlX3RpbWU9MTY2NTQ1OTMxMyZjb25uZWN0aW9uX2RhdGE9dGVzdCZpbml0aWFsX2xheW91dF9jbGFzc19saXN0PQ=="
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/credentials.json
 ** module id = 211
 ** module chunks = 0
 **/